<template>
    <div>
        <div class="row mt20">
            <div class="col-md-5 pa10">
                <div class="content-wizard pa20 minHeight100">
                    <div class="row">
                        <div v-if="entity === 'renault'" class="col-md-12 largeTitle">
                            <i class="fa fa-eur"></i>
                            Estimation Renault Sell Your Car
                            <hr>
                        </div>
                        <div v-else class="col-md-12 largeTitle">
                            <i class="fa fa-eur"></i>
                            Estimation Carizy
                            <hr>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6" :class="{'has-error': sellerPriceTooHigh}">
                            <label class="greenText">Prix net vendeur (€):</label>
                            <p class="text25px greenText mt10">
                                {{ maxSellerPrice }}
                            </p>
                        </div>
                        <div class="form-group col-md-6">
                            <div>
                                <label>Code Promo ou Parrainage</label>
                                <div class="row">
                                    <div class="col-md-9">
                                        <input type="text"
                                            class="form-control maxWidth300px"
                                            :disabled="estimationInfos.disablePromoCode"
                                            v-model="estimationInfos.promoCode">
                                    </div>
                                    <div class="col-md-2 largeTitle cursorPointer"
                                        :class="{ 'sk-loading': checkPromoCodeIsLoading }"
                                        @click="validatePromoCode"
                                        v-if="!estimationInfos.disablePromoCode"
                                    >
                                        <spinner-double-bounce :displayNone="!checkPromoCodeIsLoading"/>
                                        <i class="fa fa-plus" v-if="!checkPromoCodeIsLoading"></i>
                                    </div>
                                </div>
                                <p v-if="estimationInfos.promoCodeMessage"
                                    class="mt10"
                                    :class="estimationInfos.checkPromoCodedata.isValid ? 'text-success' : 'text-error'"
                                >
                                    {{ estimationInfos.promoCodeMessage }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <p class="text17px mt20">Commission : {{ numberFormatFr(quotation.gain) }} €</p>
                    <p class="text17px">Prix de vente : {{ numberFormatFr(quotation.maxPrice) }} €</p>

                    <div class="form-group mt20">
                        <label>Commentaire</label>
                        <textarea v-model="estimationInfos.comment" class="form-control" placeholder=""></textarea>
                    </div>
                </div>

              <div class="content-wizard height135px pa20 mt20">
                <p class="text17px mt20 blueText">Estimation Reprise pro(€)</p>
                <p class="blueText text25px">{{ numberFormatFr(quotation.tradeInPrice) }} €</p>
              </div>
            </div>

            <div class="col-md-2 pa10">
                <div class="content-wizard pa20 minHeight100">
                    <div class="row">
                        <div class="col-md-12 smallTitle">
                            <i class="fa fa-bar-chart-o"></i>
                            Données marché
                            <hr>
                        </div>
                    </div>
                    <div class="row"
                        :class="{ 'sk-loading': getMarketInformationsIsLoading }"
                    >
                        <spinner-double-bounce :displayNone="!getMarketInformationsIsLoading"/>

                        <div class="col-md-12" v-if="marketInformations && !getMarketInformationsIsLoading">
                            <div v-if="marketInformations.professionalPrice">
                                <h3>Prix professionnel</h3>
                                <p class="fontSize18px">{{ numberFormatFr(marketInformations.professionalPrice) }} €</p>
                            </div>
                            <div class="mt20" v-if="marketInformations.individualPrice">
                                <h3>Prix entre particulier</h3>
                                <p class="fontSize18px">{{ numberFormatFr(marketInformations.individualPrice) }} €</p>
                            </div>
                            <div class="mt20" v-if="marketInformations.kilometersInformation">
                                <h3>Kilométrage moyen</h3>
                                <p class="fontSize18px">{{ numberFormatFr(marketInformations.kilometersInformation) }} Km</p>
                            </div>
                            <div class="mt20" v-if="marketInformations.timeSale">
                                <h3>Délai moyen</h3>
                                <p class="fontSize18px">{{ numberFormatFr(marketInformations.timeSale) }} jours</p>
                            </div>
                            <div class="mt20" v-if="marketInformations.marketRotate">
                                <h3>Délai de rotation</h3>
                                <p class="fontSize18px">{{ numberFormatFr(marketInformations.marketRotate ) }} jours</p>
                            </div>
                            <div class="mt20" v-if="marketInformations.numberTransaction">
                                <h3>Nombre de transaction</h3>
                                <p class="fontSize18px">{{ numberFormatFr(marketInformations.numberTransaction ) }}</p>
                            </div>
                            <div class="mt20" v-if="marketInformations.autobizMarketUrl">
                                <a :href="marketInformations.autobizMarketUrl" target="_blank">Voir plus</a>
                            </div>
                        </div>
                        <div v-else class="row">
                            <div class="col-md-12">
                                <p class="text-error">
                                    {{ this.marketInformationsMessage }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-5 pa10">
                <div class="content-wizard pa20 minHeight100">
                    <div class="row">
                        <div class="col-md-12 smallTitle">
                            <i class="fa fa-trophy"></i>
                            Avantages Carizy
                            <hr>
                        </div>
                    </div>
                    <div class="row pl-15">
                        <div class="col-sm-1 no-paddings">
                            <img v-if="entity === 'renault'" src="../../../assets/renault/Inspection.png" />
                            <img v-else src="../../../assets/service/Voiture-neuve.png" />
                        </div>
                        <div class="col-sm-11">
                            <h3>Inspection gratuite à domicile</h3>
                            <p>Diagnostic / 40 photos de qualité professionelle / mise en valeur de l'annonce</p>
                        </div>
                    </div>
                    <div class="row pl-15">
                        <div class="col-sm-1 no-paddings">
                            <img v-if="entity === 'renault'" src="../../../assets/renault/Meilleur-prix.png" />
                            <img v-else src="../../../assets/service/Meilleur-prix.png"/>
                        </div>
                        <div class="col-sm-11">
                            <h3>Nous fixons le bon prix</h3>
                            <p>Estimation réaliste avec la réalité du marché</p>
                        </div>
                    </div>
                    <div class="row pl-15 pb-15">
                        <div class="col-sm-1 no-paddings">
                            <img v-if="entity === 'renault'" src="../../../assets/renault/Véhicule-inspecté.png" />
                            <img v-else src="../../../assets/service/Large-choix.png" />
                        </div>
                        <div class="col-sm-11">
                            <h3>Nous vous trouvons un acheteur sérieux</h3>
                        </div>
                    </div>
                    <div class="row pl-15">
                        <div class="col-sm-1 no-paddings">
                            <img v-if="entity === 'renault'" src="../../../assets/renault/Paiement-sécurisé.png" />
                            <img v-else src="../../../assets/service/Paiement-securise.png" />
                        </div>
                        <div class="col-sm-11">
                            <h3>Nous assurons un paiement 100% sécurisé</h3>
                            <p>Vérification de la solvabilité de l'acheteur et de son moyen de paiement</p>
                        </div>
                    </div>
                    <div class="row pl-15">
                        <div class="col-sm-1 no-paddings">
                            <img v-if="entity === 'renault'" src="../../../assets/renault/Formalités.png" />
                            <img v-else src="../../../assets/service/Rapport-inspection.png" />
                        </div>
                        <div class="col-sm-11">
                            <h3>Nous nous occupons de toutes les formalités</h3>
                            <p>Organisation de la cession et des démarches administratives</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="row mt20">
            <div class="col-md-12 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-check"></i>
                            Accord du vendeur
                            <hr>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div @click="onChangeExclusivityCheckbox" class="col-md-1">
                            <div class="carizyPretty pretty p-switch p-fill">
                                <input type="checkbox" v-model="estimationInfos.exclusivityCheckbox"/>
                                <div class="state p-success">
                                    <label></label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-11">
                            <label @click="onChangeExclusivityCheckbox" class="cursorPointer">
                                Le vendeur est d'accord avec les 35 jours d'exclusivité
                                <span v-if="entity === 'renault'"
                                v-tooltip.top-center="'Le client s’engage à ne pas vendre le véhicule par ses propres moyens le temps de la période d’exclusivité qui le lie à Sell Your Car.'">
                                    <i class="fa fa-info-circle"></i>
                                </span>
                                <span v-else
                                v-tooltip.top-center="'Le client s’engage à ne pas vendre le véhicule par ses propres moyens le temps de la période d’exclusivité qui le lie à Carizy.'">
                                    <i class="fa fa-info-circle"></i>
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div @click="onChangeSellerPriceCheckbox" class="col-md-1">
                            <div class="carizyPretty pretty p-switch p-fill">
                                <input type="checkbox" v-model="estimationInfos.sellerPriceCheckbox"/>
                                <div class="state p-success">
                                    <label></label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-11">
                            <label @click="onChangeSellerPriceCheckbox" class="cursorPointer">Le vendeur est d'accord avec le prix net vendeur</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt20">
            <div class="col-md-12 pa10">
                <div class="pa20 centerText">
                    <div class="row">
                        <button
                                @click="validateQuote"
                                type="button"
                                :disabled="!estimationInfos.exclusivityCheckbox || !estimationInfos.sellerPriceCheckbox || sellerPriceTooHigh"
                                class="btn btn-w-m buttonLarge"
                                :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
                        >
                            Valider cette estimation
                        </button>
                    </div>
                    <div class="row mt20">
                        <p>ou</p>
                        <p @click="showSendQuote"
                            class="underlinedText cursorPointer"
                            v-scroll-to="'#sendQuote'"
                        >
                            Envoyer cette estimation
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt20" v-if="estimationInfos.showSendQuoteClicked">
            <div class="col-md-12 pa10">
                <div class="content-wizard pa20">
                    <div class="row">
                        <div class="col-md-12 largeTitle">
                            <i class="fa fa-envelope"></i>
                            Envoi de la côte par email
                            <hr>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div class="form-group col-md-6"
                            :class="{'has-error': (formErrors.firstName && !estimationInfos.seller.firstName)}"
                        >
                            <label>Prénom *</label>
                            <input name="seller.firstName"
                                type="text"
                                class="form-control"
                                v-model="estimationInfos.seller.firstName">
                        </div>
                        <div class="form-group col-md-6"
                            :class="{'has-error': (formErrors.lastName && !estimationInfos.seller.lastName)}"
                        >
                            <label>Nom *</label>
                            <input name="seller.lastName"
                                type="text"
                                class="form-control"
                                v-model="estimationInfos.seller.lastName">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="formErrors.firstName && !estimationInfos.seller.firstName" class="alert alert-danger">
                                Désolé, un prénom est nécessaire
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div v-if="formErrors.lastName  && !estimationInfos.seller.lastName" class="alert alert-danger">
                                Désolé, un nom est nécessaire
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-6"
                            :class="{'has-error': (formErrors.email && errors.first('seller.email'))}"
                        >
                            <label>Email *</label>
                            <input name="seller.email"
                                v-validate="'required|email'"
                                type="text"
                                class="form-control"
                                v-model="estimationInfos.seller.email">
                        </div>
                        <div class="form-group col-md-6"
                            :class="{'has-error': (formErrors.phone && sellerPhoneError)}"
                        >
                            <label>Téléphone *</label>
                            <input name="seller.phone"
                                type="text"
                                class="form-control"
                                v-model="estimationInfos.seller.phone">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="formErrors.email && errors.first('seller.email')" class="alert alert-danger">
                                Désolé, l'email ne respecte pas nos conditions
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div v-if="formErrors.phone && sellerPhoneError" class="alert alert-danger">
                                Désolé, le téléphone ne respecte pas nos conditions (10 chiffres)
                            </div>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div @click="onChangeSellerMarketingRadio" class="col-md-1">
                            <div class="carizyPretty pretty p-switch p-fill">
                                <input type="checkbox" v-model="estimationInfos.seller.marketingRadio"/>
                                <div class="state p-success">
                                    <label></label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-11">
                            <label @click="onChangeSellerMarketingRadio" class="cursorPointer" v-if="entity === 'renault'">Le client accepte de recevoir des communications et des offres personalisées de la part de Renault Sell Your Car.</label>
                            <label @click="onChangeSellerMarketingRadio" class="cursorPointer" v-else>Le client accepte de recevoir des communications et des offres personalisées de la part de Carizy.</label>
                        </div>
                    </div>
                    <div class="row mt20" v-if="estimationInfos.seller.marketingRadio">
                        <div class="col-md-1"></div>
                        <div class="col-md-11">
                            <div>
                                <label>Par sms :</label>
                                <button
                                    v-for="option in trueFalseOptions"
                                    :key="option.text"
                                    @click="updateMarketingSmsValue(option)"
                                    type="button"
                                    class="btn btn-w-m mt20 mr6"
                                    :class="[option.value === estimationInfos.seller.marketingSmsCheckbox ? 'btn-primary' : 'btn-secondary']"
                                >
                                    {{ option.text }}
                                </button>
                            </div>
                            <div class="mt20">
                                <label>Par email:</label>
                                <button
                                    v-for="option in trueFalseOptions"
                                    :key="option.text"
                                    @click="updateMarketingEmailValue(option)"
                                    type="button"
                                    class="btn btn-w-m mt20 mr6"
                                    :class="[option.value === estimationInfos.seller.marketingEmailCheckbox ? 'btn-primary' : 'btn-secondary']"
                                >
                                    {{ option.text }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row mt20">
                        <div @click="onChangeSellerMarketingPartnerRadio" class="col-md-1">
                            <div class="carizyPretty pretty p-switch p-fill">
                                <input type="checkbox" v-model="estimationInfos.seller.marketingPartnerRadio"/>
                                <div class="state p-success">
                                    <label></label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-11">
                            <label @click="onChangeSellerMarketingPartnerRadio" class="cursorPointer" v-if="entity === 'renault'">Le client accepte que ses coordonnées téléphoniques soient transmises aux partenaires de Renault Sell Your Car.</label>
                            <label @click="onChangeSellerMarketingPartnerRadio" class="cursorPointer" v-else>Le client accepte que ses coordonnées téléphoniques soient transmises aux partenaires de CARIZY.com.</label>
                        </div>
                    </div>
                    <div class="row mt20 centerText"
                        :class="{ 'sk-loading': sendQuoteIsLoading }"
                    >
                        <spinner-double-bounce :displayNone="!sendQuoteIsLoading"/>

                        <button
                            @click="sendQuote"
                            v-if="!sendQuoteIsLoading"
                            type="button"
                            class="btn btn-w-m mt20"
                            :class="[entity === 'renault' ? 'btn-renault' : 'btn-carizy']"
                        >
                            Envoyer
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div id="sendQuote"></div>
    </div>
</template>


<script>
    import gql from 'graphql-tag'
    import SpinnerDoubleBounce from '@/components/spinners/SpinnerDoubleBounce'
    import { numberFormatFrMixin } from '@/mixins/numberFormatFrMixin'

    export default {
        name: "Estimation",

        components: {
            SpinnerDoubleBounce
        },

        mixins: [numberFormatFrMixin],

        props: {
            activeStep: {
                type: Number,
                required: true
            },
            entity: {
                type: String,
                required: true
            },
            vehicle: {
                type: Object
            },
            quotation: {
                type: Object,
            },
            estimationInfosProp: {
                type: Object
            },
        },

        data: () => ({
            autoSave: null,
            sendQuoteIsLoading: false,
            getMarketInformationsIsLoading: false,
            checkPromoCodeIsLoading: false,
            marketInformations: null,
            marketInformationsMessage: "",
            trueFalseOptions: [
                { text: "Oui", value: true },
                { text: "Non", value: false },
            ],
            quotationId: "",
            estimationInfos: {
                promoCode: "",
                promoCodeMessage: "",
                disablePromoCode: false,
                checkPromoCodedata: {
                    isValid: false
                },
                sellerPrice: null,
                exclusivityCheckbox: false,
                sellerPriceCheckbox: false,
                seller: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    marketingRadio: false,
                    marketingPartnerRadio: false,
                    marketingSmsCheckbox: "",
                    marketingEmailCheckbox: "",
                },
                showSendQuoteClicked: false,
                comment: ""
            },
            formErrors: {
                firstName: false,
                lastName: false,
                email: false,
                phone: false
            },
        }),

        beforeDestroy () {
            clearInterval(this.autoSave)
        },

        created () {
            this.autoSaveData()
        },

        methods: {
            scrollToTop() {
                window.scrollTo(0,0);
            },
            autoSaveData () {
                this.autoSave = setInterval(() => {
                    this.$emit('pass-estimation-infos-data', this.estimationInfos)
                }, 1000)
            },
            goToPreviousStep () {
                clearInterval(this.autoSave)
                this.$emit('go-to-previous-step', 1)
            },
            goToNextStep () {
                clearInterval(this.autoSave)
                this.$emit('pass-estimation-infos-data', this.estimationInfos)
                this.$emit('go-to-next-step', 3)
            },
            validateQuote () {
                this.goToNextStep()
            },
            validatePromoCode () {
                if(!this.estimationInfos.disablePromoCode){
                    this.checkPromoCodeIsLoading = true
                    this.estimationInfos.promoCodeMessage = ""
                    this.estimationInfos.checkPromoCodedata = {
                        isValid: false
                    },

                    this.$apollo.query({
                        query: this.checkPromoCodeQuery,
                        fetchPolicy: 'no-cache'
                    }).then(response => {
                        this.estimationInfos.checkPromoCodedata = response.data.checkPromoCode
                        if(this.estimationInfos.checkPromoCodedata.isValid){
                            if(this.estimationInfos.checkPromoCodedata.name.includes('@')){
                                this.estimationInfos.promoCodeMessage = "Le code parrainage a bien été pris en compte, vous bénéficierez d'une carte essence !"
                            } else {
                                this.estimationInfos.promoCodeMessage = "Le code promo donne le droit à une réduction de 10% sur notre commission."
                            }
                        } else {
                            const wrongPromocode = this.estimationInfos.promoCode
                            this.estimationInfos.promoCodeMessage = "Ce code ne fonctionne pas: " + wrongPromocode
                            this.estimationInfos.promoCode = ""
                        }
                        this.checkPromoCodeIsLoading = false
                    }, () => {
                        this.showBanner('danger', "Désolé, impossible de vérifier la validité du code promo.")
                        this.checkPromoCodeIsLoading = false
                        const wrongPromocode = this.estimationInfos.promoCode
                        this.estimationInfos.promoCodeMessage = "Désolé, impossible de vérifier la validité du code: " + wrongPromocode
                        this.estimationInfos.promoCode = ""
                    })
                }
            },
            isFormValid () {
                this.formErrors =  {
                    firstName: false,
                    lastName: false,
                    email: false,
                    phone: false
                }
                if(!this.estimationInfos.seller.firstName){
                    this.formErrors.firstName = true
                }
                if(!this.estimationInfos.seller.lastName){
                    this.formErrors.lastName = true
                }
                if(!this.estimationInfos.seller.email || this.errors.first('seller.email')){
                    this.formErrors.email = true
                }
                if(!this.estimationInfos.seller.phone || this.sellerPhoneError){
                    this.formErrors.phone = true
                }

                if(
                    this.formErrors.firstName ||
                    this.formErrors.lastName  ||
                    this.formErrors.email  ||
                    this.formErrors.phone
                ){
                    return false
                } else {
                    return true
                }
            },
            sendQuote () {
                if(this.isFormValid()){
                    // CREATE OR UPDATE CUSTOMER
                    this.createOrUpdateCustomer()

                    // NEXT STEP: CREATE QUOTATION IF NEEDED OR/AND SEND QUOTE PER EMAIL (see createOrUpdateCustomer())
                }
            },
            showSendQuote () {
                this.estimationInfos.showSendQuoteClicked = !this.estimationInfos.showSendQuoteClicked
            },
            onChangeMarketingRadio () {
                this.estimationInfos.seller.marketingSmsCheckbox = false
                this.estimationInfos.seller.marketingEmailCheckbox = false
            },
            onChangeExclusivityCheckbox () {
                this.estimationInfos.exclusivityCheckbox = !this.estimationInfos.exclusivityCheckbox
            },
            onChangeSellerPriceCheckbox () {
                this.estimationInfos.sellerPriceCheckbox = !this.estimationInfos.sellerPriceCheckbox
            },
            updateMarketingSmsValue (option) {
                this.estimationInfos.seller.marketingSmsCheckbox = option.value
            },
            updateMarketingEmailValue (option) {
                this.estimationInfos.seller.marketingEmailCheckbox = option.value
            },
            onChangeSellerMarketingRadio () {
                this.estimationInfos.seller.marketingRadio = !this.estimationInfos.seller.marketingRadio
                if(this.estimationInfos.seller.marketingRadio){
                    this.estimationInfos.seller.marketingSmsCheckbox = true
                    this.estimationInfos.seller.marketingEmailCheckbox = true
                } else {
                    this.estimationInfos.seller.marketingSmsCheckbox = ""
                    this.estimationInfos.seller.marketingEmailCheckbox = ""
                }
            },
            onChangeSellerMarketingPartnerRadio () {
                this.estimationInfos.seller.marketingPartnerRadio = !this.estimationInfos.seller.marketingPartnerRadio
            },
            async createOrUpdateCustomer () {
                this.sendQuoteIsLoading = true

                if(this.estimationInfos.seller.marketingSmsCheckbox === ""){
                  this.estimationInfos.seller.marketingSmsCheckbox = false
                }
                if(this.estimationInfos.seller.marketingEmailCheckbox === ""){
                  this.estimationInfos.seller.marketingEmailCheckbox = false
                }

                if(this.quotation && this.quotation.customer && this.quotation.customer.id){
                    this.$apollo.mutate({
                        mutation: this.customerMutation
                    }).then(response => {
                        this.showBanner('success', 'Le client a bien été créé ou mis à jour')
                        this.sendQuoteIsLoading = false

                        // NEXT STEP: CREATE QUOTATION IF NEEDED OR SEND QUOTE PER EMAIL
                        if(!this.quotation.id){
                            this.createQuotation()
                        } else {
                            this.sendEmailWithQuotation()
                        }
                    }, () => {
                        this.showBanner('danger', 'Désolé, un problème est survenu lors de la création ou de la mise à jour du client')
                        this.sendQuoteIsLoading = false
                    })
                } else {
                    this.$apollo.mutate({
                        mutation: this.customerMutationWithoutId
                    }).then(response => {
                        this.showBanner('success', 'Le client a bien été créé ou mis à jour')
                        this.sendQuoteIsLoading = false

                        // NEXT STEP: CREATE QUOTATION IF NEEDED OR SEND QUOTE PER EMAIL
                        if(!this.quotation.id){
                            this.createQuotation()
                        } else {
                            this.sendEmailWithQuotation()
                        }
                    }, () => {
                        this.showBanner('danger', 'Désolé, un problème est survenu lors de la création ou de la mise à jour du client')
                        this.sendQuoteIsLoading = false
                    })
                }
            },
            async createQuotation () {
                this.sendQuoteIsLoading = true

                this.$apollo.mutate({
                    mutation: this.addQuotationMutation
                }).then(response => {
                    this.quotationId = response.data.addQuotation.quotation.id
                    this.showBanner('success', 'La côte a bien été créée')
                    this.sendQuoteIsLoading = false

                    // NEXT STEP: SEND QUOTE PER EMAIL
                    this.sendEmailWithQuotation()
                }, () => {
                    this.showBanner('danger', 'Désolé, un problème est survenu lors de la création de la côte')
                    this.sendQuoteIsLoading = false
                })
            },
            async sendEmailWithQuotation () {
                this.sendQuoteIsLoading = true

                this.$apollo.mutate({
                    mutation: this.sendQuotationMutation
                }).then(response => {
                    this.showBanner('success', 'Le côte a bien été envoyée par email')
                    this.sendQuoteIsLoading = false
                }, () => {
                    this.showBanner('danger', "Désolé, un problème est survenu lors de l'envoi de la côte par email")
                    this.sendQuoteIsLoading = false
                })
            },
            async getLatestMarketInformations () {
                this.getMarketInformationsIsLoading = true
                this.marketInformationsMessage = ""

                if(this.vehicle.kilometer){
                    if(this.vehicle && this.vehicle.version && this.vehicle.version.id){
                        this.$apollo.query({
                            query: this.getMarketInformationsQueryWithVersionId,
                            fetchPolicy: 'no-cache'
                        }).then(response => {
                            this.marketInformations= response.data.getMarketInformations
                            this.getMarketInformationsIsLoading = false
                        }, () => {
                            this.marketInformationsMessage = "Désolé, les infos marché ne sont pas disponibles."
                            this.showBanner('danger', this.marketInformationsMessage)
                            this.getMarketInformationsIsLoading = false
                        })
                    } else {
                        if(this.quotation && this.quotation.car && this.quotation.car.id && this.quotation.car.releaseDate){
                            this.$apollo.query({
                                query: this.getMarketInformationsQueryWithCarId,
                                fetchPolicy: 'no-cache'
                            }).then(response => {
                                this.marketInformations= response.data.getMarketInformations
                                this.getMarketInformationsIsLoading = false
                            }, () => {
                                this.marketInformationsMessage = "Désolé, les infos marché ne sont pas disponibles."
                                this.showBanner('danger', this.marketInformationsMessage)
                                this.getMarketInformationsIsLoading = false
                            })
                        } else {
                            if(!this.quotation.car.releaseDate){
                                this.marketInformationsMessage = "Désolé, il nous faudrait la releaseDate du véhicule pour pouvoir montrer les infos marché."
                            }
                            if(!this.quotation.car.id && !this.quotation.car.id){
                                this.marketInformationsMessage = "Désolé, il nous faudrait le carId ou la versionId du véhicule pour pouvoir montrer les infos marché."
                            }
                            this.showBanner('danger', this.marketInformationsMessage)
                            this.getMarketInformationsIsLoading = false
                        }
                    }
                } else {
                    this.marketInformationsMessage = "Désolé, il nous faudrait le kilométrage du véhicule pour pouvoir montrer les infos marché."
                    this.showBanner('danger', this.marketInformationsMessage)
                    this.getMarketInformationsIsLoading = false
                }
            },
        },

        computed: {
            maxSellerPrice () {
                return parseInt(this.quotation.sellerPrice)
            },
            sellerPriceTooHigh () {
                if(this.maxSellerPrice < this.estimationInfos.sellerPrice){
                    return true
                } else {
                    return false
                }
            },
            sellerPhoneError () {
                if(this.estimationInfos.seller.phone.length !== 10) {
                    return true
                } else {
                    return false
                }
            },
            sellerEmailIsValid(){
                if (
                    this.estimationInfos.seller.email &&
                    (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.estimationInfos.seller.email))
                )
                {
                    return true
                }
                return false
            },
            disableSendQuote(){
                if(
                    this.sellerPhoneError ||
                    this.errors.first('seller.email') ||
                    !this.estimationInfos.seller.firstName ||
                    !this.estimationInfos.seller.lastName ||
                    !this.estimationInfos.seller.phone ||
                    !this.estimationInfos.seller.email

                ){
                    return true
                } else {
                    return false
                }
            },
            customerMutation(){
                return gql`
                    mutation {
                    customer (
                        id: "${this.quotation.customer.id}",
                        firstName: "${this.estimationInfos.seller.firstName}",
                        lastName: "${this.estimationInfos.seller.lastName}",
                        email: "${this.estimationInfos.seller.email}",
                        phone: "${this.estimationInfos.seller.phone}",
                        optInCarizySMS: ${this.estimationInfos.seller.marketingSmsCheckbox},
                        optInCarizyMail: ${this.estimationInfos.seller.marketingEmailCheckbox},
                        optInPartner: ${this.estimationInfos.seller.marketingPartnerRadio}
                        ) {
                        id
                        status
                        result
                        }
                    }`
            },
            customerMutationWithoutId(){
                return gql`
                    mutation {
                    customer (
                        firstName: "${this.estimationInfos.seller.firstName}",
                        lastName: "${this.estimationInfos.seller.lastName}",
                        email: "${this.estimationInfos.seller.email}",
                        phone: "${this.estimationInfos.seller.phone}",
                        optInCarizySMS: ${this.estimationInfos.seller.marketingSmsCheckbox},
                        optInCarizyMail: ${this.estimationInfos.seller.marketingEmailCheckbox},
                        optInPartner: ${this.estimationInfos.seller.marketingPartnerRadio}
                        ) {
                        id
                        status
                        result
                        }
                    }`
            },
            addQuotationMutation(){
                let monthMEC = this.vehicle.monthMEC.charAt(0).toUpperCase() + this.vehicle.monthMEC.slice(1)
                return  gql`
                    mutation {
                    addQuotation (
                        realm: "${this.entity}",
                        make: ${this.vehicle.make.id},
                        model: ${this.vehicle.model.id},
                        year: ${this.vehicle.yearMEC},
                        month: "${monthMEC}",
                        fuel: "${this.vehicle.fuel.name}",
                        gear: "${this.vehicle.gearType.name}",
                        doors: ${this.vehicle.doors.name},
                        version: "${this.vehicle.version.name}",
                        versionId: "${this.vehicle.version.id}",
                        kilometer: ${this.vehicle.kilometer},
                        zipcode: "${this.vehicle.address.zipCode}",
                        licensePlate: "${this.vehicle.licensePlate}",
                        promoCode: "${this.estimationInfos.promoCode}",
                        customer: {
                            firstname: "${this.estimationInfos.seller.firstName}",
                            lastname: "${this.estimationInfos.seller.lastName}",
                            email: "${this.estimationInfos.seller.email}",
                            phone: "${this.estimationInfos.seller.phone}",
                        }
                        ) {
                        status
                        message
                        quotation {
                            id
                        }
                        }
                    }`
            },
            sendQuotationMutation(){
                let quotationId = ""
                if(this.quotation && this.quotation.id) {
                    quotationId = this.quotation.id
                } else {
                    quotationId = this.quotationId
                }

                return gql`
                    mutation {
                    sendQuotation (
                        quotationId: "${quotationId}",
                        customer: {
                            firstname: "${this.estimationInfos.seller.firstName}",
                            lastname: "${this.estimationInfos.seller.lastName}",
                            email: "${this.estimationInfos.seller.email}",
                            phone: "${this.estimationInfos.seller.phone}",
                        }
                        ) {
                        result
                        }
                    }`
            },
            getMarketInformationsQueryWithVersionId(){
                const releaseDate = moment(this.vehicle.dateMEC, "DD/MM/YYYY").format('YYYY-MM-DD')
                return gql`
                    query {
                    getMarketInformations(
                        versionId: "${this.vehicle.version.id}",
                        kilometers: "${this.vehicle.kilometer}",
                        releaseDate: "${releaseDate}"
                        ) {
                        individualPrice
                        professionalPrice
                        kilometersInformation
                        marketRotate
                        gapTransaction
                        timeTransaction
                        numberTransaction
                        timeSale
                        autobizMarketUrl
                        }
                    }`
            },
            getMarketInformationsQueryWithCarId(){
                return gql`
                    query {
                    getMarketInformations(
                        carId: "${this.quotation.car.id}",
                        kilometers: "${this.vehicle.kilometer}",
                        releaseDate: "${this.quotation.car.releaseDate}"
                        ) {
                        individualPrice
                        professionalPrice
                        kilometersInformation
                        marketRotate
                        gapTransaction
                        timeTransaction
                        numberTransaction
                        timeSale
                        autobizMarketUrl
                        }
                    }`
            },
            checkPromoCodeQuery(){
                return gql`
                    query {
                    checkPromoCode(
                        codePromo: "${this.estimationInfos.promoCode}"
                        ) {
                        isValid
                        name
                        value
                     }
                 }`
            },
        },

        mounted () {
            this.scrollToTop()

            this.getLatestMarketInformations ()

            if(this.estimationInfosProp){
                this.estimationInfos = this.estimationInfosProp
            } else {
                this.estimationInfos.sellerPrice = parseInt(this.quotation.sellerPrice)
            }

            if(this.quotation && this.quotation.customer){
                this.estimationInfos.seller.firstName = this.quotation.customer.firstname
                this.estimationInfos.seller.lastName = this.quotation.customer.lastname
                this.estimationInfos.seller.email = this.quotation.customer.email
                this.estimationInfos.seller.phone = this.quotation.customer.phone
            }

            if(this.quotation && this.quotation.id){
                if(this.quotation.promoCode){
                    this.estimationInfos.promoCode = this.quotation.promoCode
                    this.estimationInfos.promoCodeMessage = "Le code promo donne le droit à une réduction de 10% sur notre commission."
                    this.estimationInfos.checkPromoCodedata.isValid = true
                }
                this.estimationInfos.disablePromoCode = true
            }

            $(document).trigger('vue-loaded')
        }
    }
</script>

<style scoped>

</style>